import React from "react";
import classes from "./ModalInfo.module.css";
import { useTranslation } from "react-i18next";
import SmallLoader from "./Loaders/SmallLoader";

const DeleteModal = ({ setDeleteModal, deletePicHandler, deleteLoading }) => {
    const { t } = useTranslation();

    return (
        <div className={classes.container} onClick={() => setDeleteModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.info}>
                    <img
                        src="/assets/images/warning.png"
                        alt="warning"
                        className={classes.img}
                    />
                </div>
                <div className={classes.msg}>
                    <p className={classes.text}>{t("150")}
                    </p>
                </div>
                <div className={classes.btns_container}>
                    <button className={classes.btn} type="button" disabled={deleteLoading} onClick={() => deletePicHandler()}>
                        {deleteLoading ? <SmallLoader /> : t("80")}
                    </button>
                    <button
                        className={classes.btn_2}
                        type="button"
                        disabled={deleteLoading}
                        onClick={() => setDeleteModal(false)}
                    >
                        {t("81")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;